import React from 'react';
import { SortItem } from 'component/common/SortItem/SortItem';
import { SortCardProps } from 'component/page/search/SortAndFilter/Sort/SortCard.types';
import { getSortItems } from 'component/page/search/SortAndFilter/Sort/sort.utils';
import { Box, Typography } from '@drone-js/core';

const SortCard: React.FC<SortCardProps> = React.memo((props) => {
    const items = React.useMemo(() => getSortItems(props.cms, props.sortMatrix, props.currentSort), [props.cms, props.currentSort, props.sortMatrix]);
    if (!items.length) {
        return null;
    }

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const selectedItem = items.find((item) => item.type === e.target.value);
        if (selectedItem) {
            props.onChangeHandler({ code: selectedItem.code, order: selectedItem.order }, index);
        }
    };

    return (
        <Box px="16" pb="24" data-testid="activities-sort-container">
            <Typography
                mb="16"
                data-testid="activities-sort-heading"
                variant="heading-default"
                role="heading"
                aria-level={2}
                aria-label={props.cms[146541]}
                id="activities-sort-heading"
            >
                {props.cms[146541]}
            </Typography>
            <Box role="radiogroup" aria-labelledby="activities-sort-heading">
                {items.map((item, key) => (
                    <SortItem key={`${key}${props.visible}`} item={item} onChangeHandler={onChangeHandler} isLastItem={key === items.length - 1} index={key} />
                ))}
            </Box>
        </Box>
    );
});

SortCard.displayName = 'SortCard';

export default SortCard;
